import React, { Component } from 'react'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import { Redirect } from 'react-router-dom'
import { reduxForm } from 'redux-form'
import { changeSelectedDay } from '../../redux/modules/home'
import {
  loadDeliveryScheduleStart,
  loadDeliveryScheduleFailure,
  selectDelivery
} from '../../redux/modules/delivery'
import {
  selectCurrentLocationWithAddress,
  selectUserLocationId,
  isSelectedDeliveryDateActive
} from '../../redux/modules/selectors'
import ConfirmRegisterForm from '../register/ConfirmRegister'
import { Article, SpinnerCard } from '../common/Layout'
import DeliveryList from './DeliveryList'
import DayPicker from './DayPicker'
import OrderStatus from './OrderStatus'
import ComingSoon from '../coming-soon/ComingSoon'
import { uniqBy } from 'lodash'
import PiggyBank from '../community/PiggyBank'
import { confirmPasswordStart } from '../../redux/modules/user'
import { loadProfileStart } from '../../redux/modules/profile'
import { loadLocationStart } from '../../redux/modules/location'
import { loadOrderStart } from '../../redux/modules/orderDetail'
import { loadAvailableCreditsStart } from '../../redux/modules/creditHistory'
import {
  getFriendRequestCount,
  getFriendsOrdersStart,
  loadFriendsStart
} from '../../redux/modules/friends'
import UpdateUserLocationPanel from '../location-search/UpdateUserLocationPanel'
import ModalPopup from '../common/ModalPopup'
import { noLocationRoute } from '../../routes/routes'
import OrderStatusSidebar from '../common/OrderStatusSidebar'
import { SimpleSpinner } from '../common/SimpleSpinner'
import { checkPiggybankStatusStart } from '../../redux/modules/featureToggles'

export const ConfirmRegisterContainer = reduxForm({ form: 'confirmpassword' })(
  ConfirmRegisterForm
)

const LoadDayError = () => (
  <div className="center-xs">
    <h5 className="error center-xs">
      <i className="icon-warning" /> Oops! Something went wrong.
    </h5>
    <p>
      Try refreshing the page or switching between days. If this problem
      persists, please <a href={`/contact`}>contact support</a>
    </p>
  </div>
)

class Home extends Component {
  componentDidMount() {
    const {
      match: {
        params: { locationId }
      }
    } = this.props
    const { isAuthenticated, loadLocationStart } = this.props
    loadLocationStart(locationId)
    this.fetchDeliveries(locationId)
    if (isAuthenticated) {
      this.fetchPageData(locationId)
    }
  }

  componentDidUpdate(prevProps) {
    const { isAuthenticated, loadLocationStart } = this.props
    let {
      match: {
        params: { locationId = 0 }
      }
    } = this.props
    locationId = Number(locationId)
    if (Number(prevProps.match.params.locationId) !== locationId) {
      loadLocationStart(locationId)
      this.fetchDeliveries(locationId)
    }
    if (prevProps.isAuthenticated === false && isAuthenticated === true) {
      this.fetchPageData(locationId)
    }
  }

  fetchDeliveries = locationId => {
    const { selectedDate, loadDeliveryScheduleStart } = this.props
    loadDeliveryScheduleStart(locationId, selectedDate)
  }

  fetchPageData = currentLocationId => {
    const {
      isAuthenticated,
      loadOrderStart,
      loadAvailableCreditsStart,
      getFriendRequestCount,
      getFriendsOrdersStart,
      loadFriendsStart,
      selectedDate,
      checkPiggybankStatusStart
    } = this.props
    const locationId =
      currentLocationId || Number(this.props.match.params.locationId)
    if (isAuthenticated) {
      checkPiggybankStatusStart(locationId)
      loadOrderStart(selectedDate, locationId)
      loadAvailableCreditsStart()
      getFriendRequestCount('INCOMING')
      getFriendsOrdersStart(
        format(this.props.selectedDate, 'YYYY-MM-DD'),
        locationId
      )
      loadFriendsStart()
    }
  }

  passwordVisibility() {
    let currentType = document.getElementById('loginPassword')
    currentType.type === 'password'
      ? (currentType.type = 'text')
      : (currentType.type = 'password')
  }

  render() {
    const {
      deliveries,
      deliveryError,
      isLoadingDeliveries,
      selectDelivery,
      isAuthenticated,
      profile,
      isCurrentUserLoading,
      changeSelectedDay,
      location,
      isLocationLoading,
      userLocationId,
      hasChangedLocation,
      activationDate,
      todaysDate,
      selectedDate,
      loadingNewDay,
      isSelectedDayActive,
      confirmPasswordStart,
      confirmPasswordError,
      orders,
      isOrdersLoading,
      submitting,
      isLoadingFriendsOrders,
      friendsOrderCount,
      piggybankStatus,
      isCheckingStatus,
      friends
    } = this.props
    let {
      friendHasOrdered,
      match: {
        params: { locationId }
      }
    } = this.props
    locationId = Number(locationId)

    const newUser = profile && profile.status !== 'CONFIRMED'
    const inActiveLocation =
      location && location.activationDate === null ? (
        <Redirect to={noLocationRoute.path} />
      ) : null

    const changeLocationModal =
      !isCurrentUserLoading &&
      isAuthenticated &&
      !hasChangedLocation &&
      locationId.toString() !== userLocationId.toString() ? (
        <ModalPopup showCancel={false}>
          <UpdateUserLocationPanel locationId={locationId} />
        </ModalPopup>
      ) : null
    return (
      <Article>
        <div>
          {newUser && (
            <ModalPopup showCancel={false}>
              <ConfirmRegisterContainer
                submitting={submitting}
                confirmPasswordError={confirmPasswordError}
                onSubmit={confirmPasswordStart}
              />
            </ModalPopup>
          )}
          {inActiveLocation}
          {changeLocationModal}
          {orders && orders.length >= 0 && piggybankStatus ? (
            <SpinnerCard
              spinnerActive={
                isOrdersLoading ||
                isLoadingDeliveries ||
                isLoadingFriendsOrders ||
                isCheckingStatus
              }
            >
              <div className="statusContainer">
                <PiggyBank
                  {...{
                    friends,
                    friendsOrderCount:
                      friendsOrderCount &&
                      uniqBy(
                        friendsOrderCount.reduce(
                          (ordered, i) => ordered.concat(i),
                          []
                        ),
                        'userId'
                      ),
                    orders,
                    locationId,
                    activeOrders:
                      orders &&
                      orders.filter(order => order.orderState !== 'CANCELED')
                  }}
                />
              </div>
            </SpinnerCard>
          ) : orders && orders.length > 0 ? (
            <SpinnerCard
              spinnerActive={isLoadingDeliveries || isLoadingFriendsOrders}
            >
              <div className="statusContainer">
                <OrderStatusSidebar locationId={locationId} />
              </div>
            </SpinnerCard>
          ) : null}
          <SpinnerCard spinnerActive={isLoadingDeliveries}>
            <DayPicker
              selectedDate={selectedDate}
              todaysDate={todaysDate}
              onChangeDay={changeSelectedDay}
              activationDate={activationDate}
              locationId={locationId}
            />
            <OrderStatus order={deliveries} />
            {!deliveryError ? (
              isSelectedDayActive ? (
                <DeliveryList
                  locationId={locationId}
                  loadingNewDay={loadingNewDay}
                  deliveries={deliveries}
                  selectDelivery={selectDelivery}
                  isSelectedDayActive={isSelectedDayActive}
                  selectedDate={selectedDate}
                  friendHasOrdered={friendHasOrdered}
                />
              ) : !isLocationLoading ? (
                <ComingSoon
                  activationDate={activationDate}
                  onChangeDay={changeSelectedDay}
                  isAuthenticated={isAuthenticated}
                  locationId={locationId}
                />
              ) : (
                <SimpleSpinner />
              )
            ) : (
              <LoadDayError />
            )}
          </SpinnerCard>
        </div>
      </Article>
    )
  }
}

const mapStateToProps = state => {
  const { deliveries, isLoadingDeliveries } = state.delivery
  const deliveryError = state.delivery.error
  const {
    todaysDate,
    selectedDate,
    loadingNewDay,
    loadDeliveriesForLocation
  } = state.home
  const {
    isAuthenticated,
    isCurrentUserLoading,
    hasChangedLocation,
    currentUser,
    submitting,
    confirmPasswordError
  } = state.user
  const {
    isLoadingFriendsOrders,
    friendsOrderCount,
    friends,
    friendHasOrdered
  } = state.friends
  const { isLocationLoading } = state.location
  const location = selectCurrentLocationWithAddress(state)
  const { location: { activationDate } = {} } = state.location
  const userLocationId = selectUserLocationId(state)
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const { profile } = state.profile
  const { orders, loading } = state.orderDetail
  const { isCheckingStatus, piggybankStatus } = state.featureToggles
  return {
    activationDate,
    confirmPasswordError,
    currentUser,
    deliveries,
    deliveryError,
    friends,
    friendsOrderCount,
    hasChangedLocation,
    isAuthenticated,
    isCheckingStatus,
    isCurrentUserLoading,
    isLoadingDeliveries,
    isLoadingFriendsOrders,
    isLocationLoading,
    isSelectedDayActive,
    loadDeliveriesForLocation,
    loadingNewDay,
    location,
    orders,
    isOrdersLoading: loading,
    piggybankStatus,
    profile,
    selectedDate,
    submitting,
    todaysDate,
    userLocationId,
    friendHasOrdered
  }
}

const mapDispatchToProps = {
  changeSelectedDay,
  checkPiggybankStatusStart,
  confirmPasswordStart,
  getFriendRequestCount,
  getFriendsOrdersStart,
  loadAvailableCreditsStart,
  loadDeliveryScheduleFailure,
  loadDeliveryScheduleStart,
  loadFriendsStart,
  loadLocationStart,
  loadOrderStart,
  loadProfileStart,
  selectDelivery
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)
